import { MachinesListSupportSessionsZitadelRoleTypes } from "@common/types/machines-list-types";

interface SessionIdentityMachine {
  technician_user_id?: string;
  operator_user_id?: string;
  followers_user_ids?: string[];
  visibility?: string;
}

interface SessionIdentityAuthContext {
  userId?: string;
  permissions?: string[];
}

export interface SessionIdentityFlags {
  isCurrentUserSessionOwner: boolean;
  isCurrentUserSessionViewer: boolean;
  isCurrentUserSessionApprover: boolean;
  isManagerOwner: boolean;
  canRequestorCancelActiveInProgress: boolean;
  canApproverCancelActiveInProgress: boolean;
}

export const getSessionIdentityFlags = (
  machine: SessionIdentityMachine | null | undefined,
  authContext: SessionIdentityAuthContext | null | undefined,
): SessionIdentityFlags => {
  const isCurrentUserSessionOwner =
    !!machine?.technician_user_id &&
    !!authContext?.userId &&
    machine.technician_user_id === authContext.userId;

  const isCurrentUserSessionViewer =
    !!authContext?.userId &&
    Array.isArray(machine?.followers_user_ids) &&
    machine.followers_user_ids.some(
      (userId) => String(userId) === String(authContext.userId),
    );

  // The approver is whoever accepted/is handling the session (operator_user_id).
  const isCurrentUserSessionApprover =
    !!machine?.operator_user_id &&
    !!authContext?.userId &&
    machine.operator_user_id === authContext.userId;

  const isManagerOwner =
    !!authContext?.permissions?.includes(
      MachinesListSupportSessionsZitadelRoleTypes.MANAGE_VPN,
    ) && isCurrentUserSessionOwner;

  const hasManageVpnPermission = !!authContext?.permissions?.includes(
    MachinesListSupportSessionsZitadelRoleTypes.MANAGE_VPN,
  );

  const canRequestorCancelActiveInProgress =
    hasManageVpnPermission || isCurrentUserSessionOwner;

  const canApproverCancelActiveInProgress =
    hasManageVpnPermission || isCurrentUserSessionApprover;

  return {
    isCurrentUserSessionOwner,
    isCurrentUserSessionViewer,
    isCurrentUserSessionApprover,
    isManagerOwner,
    canRequestorCancelActiveInProgress,
    canApproverCancelActiveInProgress,
  };
};
